import { Avatar as AntAvatar } from "antd";
import { SVGs } from "../../assets";
import React from "react";
import { Constants } from "../../utils";

const Avatar = ({ image = "", name = "", ...props }) => {
  return (
    <AntAvatar
      {...props}
      style={{ background: "transparent" }}
      src={`${Constants.Project.baseUrl}${image}`}
      icon={
        <img
          src={SVGs.circleAvatarOutlined}
          style={{ width: "2.5rem", height: "2.5rem" }}
        />
      }
    />
  );
};

export default Avatar;
